export default function Contact() {
  return (
    <section className="font-mono text-sm leading-[1.7] text-black">
      <p>
        Email:{' '}
        <a href="mailto:ayushinanavati@gmail.com">ayushinanavati@gmail.com</a>
      </p>
      <p className="mt-2">
        LinkedIn:{' '}
        <a
          href="https://linkedin.com/in/ayushinanavati"
          target="_blank"
          rel="noopener noreferrer"
        >
          linkedin.com/in/ayushinanavati
        </a>
      </p>
      <p className="mt-2">
        GitHub:{' '}
        <a
          href="https://github.com/Ayyyn"
          target="_blank"
          rel="noopener noreferrer"
        >
          github.com/Ayyyn
        </a>
      </p>
      {/* <p className="mt-6">
        Available for contract work at $35-50/hour. Based in Mumbai, available
        globally.
      </p> */}
    </section>
  );
}
